import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#707070",
      d: "m8 1 1.5 4.5L14 7 9.5 8.5 8 13 6.5 8.5 2 7l4.5-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#707070",
      d: "m12 2 .75 2 2.25.75-2.25.75-.75 2-.75-2L9 4.75 11.25 4zM4 9l.5 1.5L6 11l-1.5.5L4 13l-.5-1.5L2 11l1.5-.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }